import React, { useContext, useEffect, useState } from 'react';
import { ProgressBar } from '../../NecttosComp/ProgressBar/ProgressBar';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import Input from '../../NecttosComp/Input/Input';
import Button from '../../NecttosComp/Button/Button';

export const SectionHeader = ({ title, values, keyName, array, object, percentage }: any) => {
	if (!keyName && !values && !percentage) {
		return <h2 className='flex justify-between items-center lg:text-xl text-sm font-semibold text-white bg-[#013E7F] px-6 py-1 rounded'>{title}</h2>;
	}

	let valuesData = 0;

	if (percentage) {
		valuesData = percentage;
	} else if (array) {
		const valuesDat = values[array] || [];
		let hhh = 0;
		let yyy = 0;
		valuesDat.forEach((element: any) => {
			if (keyName && Array.isArray(keyName)) {
				const filledFields = keyName.filter((k: any) => Boolean(element[k])).length;
				const totalFields = keyName.length;
				hhh += filledFields;
				yyy += totalFields;
			}
		});
		const percentage = yyy > 0 ? parseInt(((hhh / yyy) * 100).toFixed(0)) : 0;
		valuesData = percentage;
	} else if (object) {
		const newValues = values?.[object] || {};

		const filledFields = keyName?.filter((k: any) => Boolean(newValues?.[k])).length;

		const totalFields = keyName?.length;

		valuesData = parseInt(((filledFields / totalFields) * 100).toFixed(0));
	} else {
		const filledFields = keyName?.filter((k: any) => Boolean(values[k])).length;
		const totalFields = keyName?.length;
		valuesData = parseInt(((filledFields / totalFields) * 100).toFixed(0));
	}

	return (
		<h2 className='flex justify-between items-center lg:text-xl text-sm font-semibold text-white bg-[#013E7F] px-6 py-1 rounded'>
			{title}
			<div className='w-1/2'>
				<ProgressBar progress={valuesData || 0} />
			</div>
		</h2>
	);
};

interface ProgressCardProps {
	color: string;
	array?: string;
	title: string;
	object?: string;
	values: Record<string, any>;
	keyName: string[];
}

export const PercentageCalculatorProfile = ({ values, keyName, arrayKey, bbbbdddd }: any) => {
	const filledFields = keyName?.filter((k: any) => Boolean(values[k])).length;
	const totalFields = keyName.length;
	let valuesData = parseInt(((filledFields / totalFields) * 100).toFixed(0));
	let arraydata = 0;
	let objectData = 0;
	if (arrayKey) {
		arrayKey.forEach((elem: any) => {
			const valuesDat = values[elem?.title] || [];
			let hhhuu = 0;
			let yyyuu = 0;
			valuesDat.forEach((element: any) => {
				if (elem.values && Array.isArray(elem?.values)) {
					const filledFields = elem.values.filter((k: any) => Boolean(element[k])).length;

					const totalFields = elem.values.length;
					hhhuu += filledFields;
					yyyuu += totalFields;
				}
			});
			const percentage = yyyuu > 0 ? parseInt(((hhhuu / yyyuu) * 100).toFixed(0)) : 0;
			arraydata += percentage;
		});
	}
	if (bbbbdddd?.length) {
		bbbbdddd.forEach((elem: any) => {
			let hhhuu = 0;
			let yyyuu = 0;
			const newDataObject = elem;
			const newValuesee = values?.[newDataObject?.title] || {};
			const filledFields = newDataObject?.values?.filter((k: any) => Boolean(newValuesee?.[k])).length;
			const totalFields = newDataObject?.values?.length;
			hhhuu += filledFields;
			yyyuu += totalFields;
			const percentage = yyyuu > 0 ? parseInt(((hhhuu / yyyuu) * 100).toFixed(0)) : 0;
			arraydata += percentage;
		});
	}

	let overallPercentage = 0;
	const safeLengthB = bbbbdddd?.length || 0;
	const safeLengthA = arrayKey?.length || 0;
	const denominator = safeLengthB + safeLengthA + 1;

	if (denominator >= 1) {
		overallPercentage = (objectData + arraydata + valuesData) / denominator;
	}

	return overallPercentage;
};

export const ProgressCard: React.FC<ProgressCardProps> = ({ color, title, array, values, keyName, object }) => {
	let valuesData = 0;
	if (array) {
		const valuesDat = values[array] || [];
		let hhh = 0;
		let yyy = 0;
		valuesDat.forEach((element: any) => {
			if (keyName && Array.isArray(keyName)) {
				const filledFields = keyName.filter((k: any) => Boolean(element[k])).length;
				const totalFields = keyName.length;
				hhh += filledFields;
				yyy += totalFields;
			}
		});
		const percentage = yyy > 0 ? parseInt(((hhh / yyy) * 100).toFixed(0)) : 0;
		valuesData = percentage;
	} else if (object) {
		const newValues = values?.[object] || {};

		const filledFields222 = keyName?.filter((k: any) => Boolean(newValues?.[k])).length;
		const totalFields222 = keyName?.length;

		valuesData = parseInt(((filledFields222 / totalFields222) * 100).toFixed(0));
	} else {
		const filledFields = keyName?.filter((k: any) => Boolean(values[k])).length;
		const totalFields = keyName?.length;
		valuesData = parseInt(((filledFields / totalFields) * 100).toFixed(0));
	}

	return (
		<div className='text-center p-2 m-1 bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300' style={{ width: 100, height: title ? 140 : 100 }}>
			<CircularProgressbar
				value={valuesData || 0}
				text={`${valuesData || 0}%`}
				styles={buildStyles({
					rotation: 23,
					pathColor: color,
					textColor: '#212529',
					trailColor: '#f3f4f6',
					textSize: '16px',
					pathTransitionDuration: 0.5,
				})}
			/>
			<div className='mt-1 font-medium text-sm text-gray-800'>{title}</div>
		</div>
	);
};

export const Language = ['Arabic', 'Assamese', 'Bengali', 'Bhasa Melayu', 'Bhutia', 'Bodo', 'English', 'French', 'German', 'Gujarati', 'Hindi', 'Japanese', 'Kannada', 'Kashmiri', 'Latin', 'Lepcha', 'Limboo', 'Malayalam', 'Manipuri', 'Marathi', 'Mizo', 'Nepali', 'Odia', 'Persian', 'Portuguese', 'Punjabi', 'Russian', 'Sanskrit', 'Sanskrit Sahitya', 'Sanskrit Sasthra', 'Sindhi', 'Spanish', 'Syriac', 'Tamil', 'Tangkhul', 'Telugu', 'Tibetan', 'Urdu'];
export const subjects_array = ['Accommodation Service', 'Accountancy', 'Accountancy (Computerised Accounting)', 'Accounts', 'Advance Food Preparation', 'Agriculture', 'Air Conditioning & Refrigeration', 'Alternative English', 'Anthropology', 'Applied Art/Commercial Art', 'Applied Physics', 'Art', 'Auto Engineering', 'Autoshop Repairing & Practice', 'Bakery Science', 'BANKING WITH SECRETARIAL PRACTICE', 'Basic Concepts Of Health Disease & Medical Terminology-Xii', 'Basic Design', 'Beauty Therapy & Hair Designing ?Ii', 'Biology', 'BIOLOGY', 'Biology-Opthalmic', 'Biotechnology', 'BOOK- KEEPING AND ACCOUNTANCY', 'Botony', 'Business Administration', 'Business Data Processing', 'Business Process Outsourcing Skills-Xii', 'Business Studies', 'Business Studies with  Financial management', 'Business Studies with Functional management', 'Accountancy with computer accounting', 'Cash Management & House Keeping', 'Chemistry', 'Child Health Nursing', 'Civil Engineering', 'Classical Languages', 'Classification & Cataloguing', 'Clinical Bio-Chemistry', 'Clothing Construction', 'Commerce', 'COMMERCIAL CORRESPONDENCE AND COMMERCIAL GEOGRAPHY', 'Communicative English', 'Community Health Nursing', 'Computer & Life Insurance Administration', 'Computer Application', 'Computer Science', 'Confectionery', 'Consumer Behaviour & Protection', 'Cosmetic Chemistry', 'Creative Writing & Translation Studies', 'Dairy Plant Instrumentation', 'Dance-Bharatnatyam', 'Dance-Kathak', 'Dance-Kathakali', 'Dance-Kuchipudi', 'Dance-Manipuri', 'Dance-Mohiniyattam', 'Dance-Odissi', 'Data Entry Operations', 'Designing & Pattern Making', 'Dtp Cad & Multimedia', 'Dyeing & Printing', 'Economics', 'Education', 'Electric Machines', 'Electrical Appliances', 'Electrical Engineering', 'Electricity and', 'Electronic Devices & Circuits', 'Electronics', 'Element Cost Accountancy &Auditing', 'Engineering Graphics', 'Engineering Science', 'Entrepreneurship', 'Environmental Science', 'Establishment & Management Of Food Service Unit', 'Fabrication Technology', 'Fashion Designing', 'Fashion Studies', 'Financial Accounting', 'First Aid & Emergency Medical Care-Xii', 'Floriculture', 'Food & Beverage:Cost And Control', 'Food & Beverages Services', 'Food Preparation', 'Food Production', 'Food Science & Hygiene', 'Food Service', 'Functional English', 'Fundamental Of Nursing Ii', 'Gandhian Studies', 'Geography', 'Geology', 'Geometrical and Building Drawing', 'Geometrical and Mechanical Drawing', 'Geospatial Technology - Ii', 'Graphic Design', 'Graphics', 'Health Centre Management', 'Health Education & Public Relations ? Xii', 'Heritage Crafts', 'Hindi Core', 'Hindi Elective', 'History', 'Home Science', 'Human Rights And Gender Studies', 'I T Systems', 'India-Tourist Destination', 'Indian Languages', 'Informatics Practice', 'INFORMATICS PRACTICE & MANAGEMENT', 'Information Technology', 'Introduction To Financial Markets-2-Xii', 'Islamic History', 'Journalism', 'Entrepreneurship Development', 'Knowledge Traditions And Practices Of India', 'Laboratory Medicine (Clinical Path., Heom. & Histo)', 'Legal Studies', 'Lending Operations', 'Library Administration & Management', 'LIFE INSURANCE AND SALESMANSHIP', 'Literature in English', 'Malayalam Part III', 'Malayalam', 'MANAGEMENT', 'Management Of Bank Office', 'Marketing', 'Mass Media Studies', 'Maternity & Child Health Nursing - Ii', 'Mathematics', 'Meal Planning & Service', 'Mechanical Engineering', 'Microbiology', 'Midwifery', 'Milk & Milk Products', 'Milk Product Transport & Milk Co-Operatives', 'Modern Foreign Languages', 'Multimedia & Web Technology', 'Music', 'Music Carnatic (Instrument Melodic)', 'Music Carnatic (Instrument Percussion)', 'Music Carnatic (Vocal)', 'Music Hindustani (Instrument Melodic)', 'Music Hindustani (Instrument Percussion)', 'Music Hindustani (Vocal)', 'N.C.C. (National Cadet Corps)', 'Office Communication', 'Office Procedure & Practice', 'Ophthalmic Technology', 'Optics', 'Painting', 'Philosophy', 'Physical Education', 'Physics', 'Political Science', 'Politics', 'Post Harvesting Technology & Preservation', 'Poultry Diseases & Their Control', 'Poultry Nutrition & Physiology', 'Poultry Products Technology', 'Principle & Practice Of Life Insurance', 'Psychology', 'Radiation Physics', 'Radio Engineering & Audio System', 'Radiography-I (General)', 'Radiography-Ii (Special)', 'Reference Services', 'Salesmanship', 'Sanskrit Core', 'Sanskrit Elective', 'Sculpture', 'Secretarial Practice & Accounting', 'Shorthand English', 'Shorthand Hindi', 'Social Work', 'Socially Useful and Productive Work', 'Sociology', 'Statistics', 'Store Accounting', 'Storekeeping', 'Textile Science', 'The Creative & Commercial Process In Mass Media ? Ii', 'Theatre Studies', 'Tour Management & Manpower Planning', 'Tourism', 'Transportation System & Management', 'Travel and Tourism', 'Travel Trade Management', 'Tv & Video Systems', 'Typography & Computer Application (English)', 'Typography & Computer Application (Hindi)', 'Understanding The Evolution And Forms Of Mass Media-Ii', 'Urdu Core', 'Urdu Elective', 'Vegetable Culture', 'Vocational Theory', 'Web Applications', 'Yoga Anatomy & Physiology', 'Zoology', 'Arabic', 'Assamese', 'Bengali', 'Bhasa Melayu', 'Bhutia', 'Bodo', 'English', 'French', 'German', 'Gujarati', 'Hindi', 'Japanese', 'Kannada', 'Kashmiri', 'Latin', 'Lepcha', 'Limboo', 'Malayalam Part II', 'Manipuri', 'Marathi', 'Mizo', 'Nepali', 'Odia', 'Persian', 'Portuguese', 'Punjabi', 'Russian', 'Sanskrit', 'Sanskrit Sahitya', 'Sanskrit Sasthra', 'Sindhi', 'Spanish', 'Syriac', 'Tamil', 'Tangkhul', 'Telugu', 'Tibetan', 'Urdu'];

export const fieldDefinitions = [
	{ key: 'name', title: 'Name (As per SSLC)' },
	{ key: 'aadhaarNumber', title: 'Aadhaar Number' },
	{ key: 'email', title: 'Email' },
	{ key: 'whatsappNumber', title: 'WhatsApp Number' },
	{ key: 'gender', title: 'Gender' },
	{ key: 'dob', title: 'Date of Birth' },
	{ key: 'bloodGroup', title: 'Blood Group' },
	{ key: 'placeOfBirth', title: 'Place of Birth' },
	{ key: 'motherTongue', title: 'Mother Tongue' },
	{ key: 'gardianName', title: 'Guardian Name' },
	{ key: 'guardianMobile', title: 'Guardian Mobile' },
	{ key: 'disabilities', title: 'Do you have disabilities?' },
	{ key: 'disabilityStatus', title: 'Select your Disability' },
	{ key: 'meritalStatus', title: 'Marital Status' },
	{ key: 'annualIncomeFigure', title: 'Annual Income in Figure' },
	{ key: 'religion', title: 'Religion' },
	{ key: 'category', title: 'Category' },
	{ key: 'caste', title: 'Caste' },
];

export const addressFields = [
	{ key: 'houseName', title: 'House Name' },
	{ key: 'place', title: 'Place' },
	{ key: 'postOffice', title: 'Post Office' },
	{ key: 'village', title: 'Village' },
	{ key: 'panchayatMunicipalityCorporation', title: 'Panchayat Municipality Corporation' },
	{ key: 'nationality', title: 'Nationality' },
	{ key: 'state', title: 'State' },
	{ key: 'district', title: 'District' },
	{ key: 'pinCode', title: 'Pincode' },
];

export const permanentAddressFields = [
	{ key: 'permanentHouseName', title: 'House Name' },
	{ key: 'permanentPlace', title: 'Place' },
	{ key: 'permanentPostOffice', title: 'Post Office' },
	{ key: 'permanentVillage', title: 'Village' },
	{ key: 'permanentPanchayatMunicipalityCorporation', title: 'Panchayat Municipality Corporation' },
	{ key: 'permanentNationality', title: 'Nationality' },
	{ key: 'permanentState', title: 'State' },
	{ key: 'permanentDistrict', title: 'District' },
	{ key: 'permanentPinCode', title: 'Pincode' },
];

export const sslcFields = [
	{ key: 'sslcInstitutionName', title: 'Institution Name' },
	{ key: 'sslcRegisterNo', title: 'Register No' },
	{ key: 'sslcBoard', title: 'Selected Board' },
	{ key: 'sslcPercentage', title: 'Percentage' },
	{ key: 'sslcYearOfPass', title: 'Year of Pass' },
];

export const plusTwoFields = [
	{ key: 'plusTwoInstitutionName', title: 'Institution Name' },
	{ key: 'plusTwoRegisterNo', title: 'Register No' },
	{ key: 'plusTwoState', title: 'Institution State' },
	{ key: 'plusTwoBoard', title: 'Course' },
	{ key: 'plusTwoStream', title: 'Stream' },
	{ key: 'plusTwoPercentage', title: 'Percentage' },
	{ key: 'totalMarkObtaioned', title: 'Total Mark Obtained' },
	{ key: 'totalMarks', title: 'Total Marks' },
	{ key: 'plusTwoYearOfPass', title: 'Year of Pass' },
	{ key: 'plusTwoNoOfChance', title: 'No of Chances (as given certificate)' },
	{ key: 'isBonusMark', title: 'Are You Eligible for Bonus Marks?' },
];

export const priorityFields = [
	{ key: 'preferedCourse1', title: 'Priority 1' },
	{ key: 'preferedCourse2', title: 'Priority 2' },
	{ key: 'preferedCourse3', title: 'Priority 3' },
	{ key: 'preferedCourse4', title: 'Priority 4' },
	{ key: 'preferedCourse5', title: 'Priority 5' },
	{ key: 'preferedCourse6', title: 'Priority 6' },
	{ key: 'preferedCourse7', title: 'Priority 7' },
	{ key: 'preferedCourse8', title: 'Priority 8' },
	{ key: 'preferedCourse9', title: 'Priority 9' },
	{ key: 'preferedCourse10', title: 'Priority 10' },
];

export const degree = [
	{
		fieldName: 'Common Course Part I',
		returnKey: 'subject1',
		options: [],
	},
	{
		fieldName: 'Common Course Part II',
		returnKey: 'subject2',
		options: [],
	},
	{
		fieldName: 'Core Course',
		returnKey: 'subject3',
		options: [],
	},
	{
		fieldName: 'Core Course 2',
		returnKey: 'subject32',
		options: [],
	},
	{
		fieldName: 'Core Course 3',
		returnKey: 'subject33',
		options: [],
	},
	{
		fieldName: 'Complementary Course I',
		returnKey: 'subject4',
		options: [],
	},
	{
		fieldName: 'Complementary Course II',
		returnKey: 'subject5',
		options: [],
	},
	{
		fieldName: 'Open Course',
		returnKey: 'subject6',
		options: [],
	},
	{
		fieldName: 'Vocational',
		returnKey: 'subject7',
		options: [],
	},
	{
		fieldName: 'Project',
		returnKey: 'subject8',
		options: [],
	},
	{
		fieldName: 'Others',
		returnKey: 'subject9',
		options: [],
	},
];
export const subjectsDL = ['Arabic', 'French', 'German', 'Hindi', 'Malayalam', 'Other Subject', 'Sanskrit', 'Tamil'];
export const subjectsComplementory = ['Other Subject', 'Aquaculture', 'Arabic', 'Auditing', 'BCom Complementary', 'BCom Core', 'BCom Open / Vocational', 'Bharathanatyam', 'Bio-informatics', 'Biochemistry', 'Biology', 'Biophysics', 'Biotechnology', 'Botany', 'Business Administration', 'Business Management', 'Chemistry', 'Chenda', 'Clinical Nutrition and Dietetics', 'Commerce', 'Communication Studies', 'Communicative English', 'Computer Application', 'Computer Science', 'Cyber Forensics', 'Economics', 'Electronics', 'English', 'English Drama', 'English Essays and Fiction', 'English Literature', 'English Poetry', 'Environmental Science', 'Family and Community Science', 'Financial Markets & Services', 'Fishery Science', 'Food Science', 'Food Technology', 'French', 'Geography', 'Geology', 'German', 'Hindi', 'History', 'History of English Literature', 'Home Science', 'Industrial fish and fisheries', 'Information Technology', 'Instrumentation', 'Islamic History', 'Journalism', 'Kathakali Sangeetham', 'Kathakali Vesham', 'Life Skills Strategies and Techniques', 'Literary Criticism', 'Maddalam', 'Malayalam', 'Management Accounting', 'Mathematics', 'Microbiology', 'Mohiniyattam', 'Music (vocal)', 'Music(Mridangam)', 'Music(Veena)', 'Music(Violin)', 'Nutrition', 'Other Subject', 'Philosophy', 'Phonetics', 'Physics', 'Political Science', 'Politics', 'Polymer Chemistry', 'Probability', 'Psychology', 'Sanskrit', 'Sanskrit General', 'Sanskrit Nyaya', 'Sanskrit Sahitya', 'Sanskrit Sastra', 'Sanskrit Special', 'Sanskrit Vedanta', 'Sanskrit Vyakarana', 'Social Work', 'Sociology', 'Statistics', 'Syriac', 'Tamil', 'Textiles of Fashion', 'Travel And Tourism', 'Zoology'];

export const SubjectInputSet = ({ fieldName, disabled, returnKey, state, setState, options }: any) => (
	<div className='w-full flex mb-1'>
		<div className='w-3/5 '>
			<Input disabled={disabled} width='100%' fieldName={fieldName} returnKey={returnKey + 'Name'} state={state} setState={setState} options={options} type='drop' />
		</div>
		<div className='w-1/5 '>
			<Input disabled={disabled} width='100%' fieldName={'OM'} returnKey={returnKey + 'ObtainedMark'} state={state} setState={setState} type='number' />
		</div>
		<div className='w-1/5 '>
			<Input disabled={disabled} width='100%' fieldName={'TM'} returnKey={returnKey + 'TotalMark'} state={state} setState={setState} type='number' />
		</div>
	</div>
);

export const DegreeSubjectInputSet = ({ fieldName, positionIndex, disabled, returnKey, state, setState, options }: any) => (
	<div className='w-full flex mb-1'>
		<div className='w-[46%] '>
			<Input disabled={disabled} width='100%' fieldName={fieldName} returnKey={returnKey + 'Name'} state={state} setState={setState} options={positionIndex === 0 ? ['English'] : positionIndex === 1 ? subjectsDL : subjectsComplementory} type='drop' />
		</div>
		<div className='w-[26%] '>
			<Input disabled={disabled} width='100%' fieldName={'MA/CCPA'} returnKey={returnKey + 'MarksAwardedCCPA'} state={state} setState={setState} type='number' />
		</div>
		<div className='w-[26%] '>
			<Input disabled={disabled} width='100%' fieldName={'MM/CR'} returnKey={returnKey + 'MaximumMarksCredit'} state={state} setState={setState} type='number' />
		</div>
	</div>
);
export const SubjectLabelSet: React.FC<any> = ({ plustwo, state }) => {
	return (
		<>
			<div className='w-full flex mb-1 bg-green-200 rounded-lg mt-3'>
				<div className='w-1/4 flex items-left border-r border-gray-300'>
					<p className='text-center'>Subject Name</p>
				</div>
				<div className='w-1/4 flex justify-center items-center border-r border-gray-300'>
					<p className='text-center'>Obtained Mark</p>
				</div>
				<div className='w-1/4 flex justify-center items-center'>
					<p className='text-center'>Total Mark</p>
				</div>
			</div>
			{plustwo.map((item: any) => (
				<div key={item.returnKey} className='w-full flex mb-1'>
					<div className='w-1/4 flex justify-center items-center border-r border-gray-300'>
						<p className='text-center'>{state[item.returnKey + 'Name']}</p>
					</div>
					<div className='w-1/4 flex justify-center items-center border-r border-gray-300'>
						<p className='text-center'>{state[item.returnKey + 'ObtainedMark']}</p>
					</div>
					<div className='w-1/4 flex justify-center items-center'>
						<p className='text-center'>{state[item.returnKey + 'TotalMark']}</p>
					</div>
				</div>
			))}
		</>
	);
};

export const SubjectLabelSetDegree: React.FC<any> = ({ plustwo, state }) => {
	return (
		<>
			<div className='w-full flex mb-1 bg-green-200 rounded-lg mt-3'>
				<div className='w-1/4 flex items-left border-r border-gray-300'>
					<p className='text-center'>Field Name</p>
				</div>
				<div className='w-1/4 flex justify-center items-center border-r border-gray-300'>
					<p className='text-center'>Marks Awarded / CCPA</p>
				</div>
				<div className='w-1/4 flex justify-center items-center'>
					<p className='text-center'>Maximum Marks / Credit</p>
				</div>
			</div>
			{plustwo?.map((item: any) => (
				<div key={item.returnKey} className='w-full flex mb-1'>
					<div className='w-1/4 flex items-left border-r border-gray-300'>
						<p className='text-center'>{item?.fieldName}</p>
					</div>
					<div className='w-1/4 flex justify-center items-center border-r border-gray-300'>
						<p className='text-center'>{state[item.returnKey + 'MarksAwardedCCPA']}</p>
					</div>
					<div className='w-1/4 flex justify-center items-center'>
						<p className='text-center'>{state[item.returnKey + 'MaximumMarksCredit']}</p>
					</div>
				</div>
			))}
		</>
	);
};
export const quotaDocuments: any = {
	meritQuata: { class_10_marksheet: true, class_12_marksheet: true },
	communityQuata: { community_quota_certificate: true },
	reservedQuata: {
		community_caste_certificate: true,
		non_creamy_layer_certificate: true,
		income_certificate: true,
	},
	sportsQuata: { sports_quota_proof: true },
	culturalQuata: { cultural_quota_proof: true },
	ewsQuata: { ews_certificate: true },
	pwdQuata: { disability_quota_certificate: true },
	lakshadweepQuata: { lakshadweep_nomination_letter: true },
};

export const quotaDocumentsfalse: any = {
	meritQuata: { class_10_marksheet: true, class_12_marksheet: true },
	communityQuata: { community_quota_certificate: false },
	reservedQuata: {
		community_caste_certificate: false,
		non_creamy_layer_certificate: false,
		income_certificate: false,
	},
	sportsQuata: { sports_quota_proof: false },
	culturalQuata: { cultural_quota_proof: false },
	ewsQuata: { ews_certificate: false },
	pwdQuata: { disability_quota_certificate: false },
	lakshadweepQuata: { lakshadweep_nomination_letter: false },
};

export const plustwo = [
	{
		fieldName: 'PART I - First Language ',
		returnKey: 'subject1',
		options: Language,
		required: true,
	},
	{
		fieldName: 'PART II - Second Language ',
		returnKey: 'subject2',
		options: Language,
		required: false,
	},
	{
		fieldName: 'PART III - Optional Subject 1',
		returnKey: 'subject3',
		options: subjects_array,
		required: true,
	},
	{
		fieldName: 'PART III - Optional Subject 2',
		returnKey: 'subject4',
		options: subjects_array,
		required: true,
	},
	{
		fieldName: 'PART III - Optional Subject 3',
		returnKey: 'subject5',
		options: subjects_array,
		required: true,
	},
	{
		fieldName: 'PART III - Optional Subject 4',
		returnKey: 'subject6',
		options: subjects_array,
		required: false,
	},
	{
		fieldName: 'PART III - Optional Subject 5 (If Any)',
		returnKey: 'subject7',
		options: subjects_array,
		required: false,
	},
];
export const getClassName = (value: any, classes: any) => {
	if (!value) {
		return '--';
	}
	const selected = classes?.find((x: any) => x._id === value);
	return selected?.className;
};

export const getDepartmentName = (value: any, classes: any) => {
	if (!value) {
		return '--';
	}
	const selected = classes?.find((x: any) => x._id === value);
	return selected?.departmentName;
};
export const getMinorName = (value: any, classes: any) => {
	if (!value) {
		return '--';
	}
	console.log({ classes });

	const selected = classes?.find((x: any) => x._id === value);
	return selected?.subjectName;
};
export const CustomTable = ({ data, fields, isAdition, classes }: any) => (
	<div className='overflow-x-auto rounded-xl'>
		<table className='min-w-full bg-gradient-to-r from-gray-50 to-gray-200 rounded-xl'>
			<tbody className='divide-y divide-gray-300'>
				{fields?.map((field: any) => (
					<tr key={field.key} className='hover:bg-gray-300'>
						<td className='px-4 py-2 font-semibold bg-slate-50 text-gray-800 text-left border border-gray-900' style={{ fontSize: '16px', width: '50%' }}>
							{field.title}
						</td>
						<td className='px-4 py-2 text-gray-900 font-bold bg-slate-50 text-left border border-gray-900' style={{ fontSize: '16px', width: '50%' }}>
							{isAdition ? getClassName(data[field.key], classes) : data[field.key]}
						</td>
					</tr>
				))}
			</tbody>
		</table>
	</div>
);

export const degreeFields = [
	{ key: 'degreeInstitutionName', title: 'Institution Name' },
	{ key: 'degreeRegisterNo', title: 'Register No' },
	{ key: 'degreeCourse', title: 'Course' },
	{ key: 'degreeUniversity', title: 'University' },
	{ key: 'degreeSpecialisation', title: 'Specialisation' },
	{ key: 'degreeCoursePattern', title: 'Course Pattern' },
	{ key: 'degreeYearOfPass', title: 'Year of Pass' },
	{ key: 'degreePercentage', title: 'Percentage' },
	{ key: 'degreeMarksObtained', title: 'CGPA/AGREE.marks obtained' },
	{ key: 'degreeMaxMarks', title: 'Maximum CGPA/Marks' },
];

export function getQuotaTypes(admissionInfo: any) {
	if (!admissionInfo) return '';
	let quotas = [];
	if (admissionInfo.managementQuata) quotas.push('Management Quota');
	if (admissionInfo.meritQuata) quotas.push('Merit Quota');
	if (admissionInfo.communityQuata) quotas.push('Community Quota');
	if (admissionInfo.reservedQuata) quotas.push('Reservation Quota');
	if (admissionInfo.sportsQuata) quotas.push('Sports Quota');
	if (admissionInfo.culturalQuata) quotas.push('Cultural Quota');
	if (admissionInfo.ewsQuata) quotas.push('EWS Quota');
	if (admissionInfo.pwdQuata) quotas.push('PwD Quota');
	if (admissionInfo.lakshadweepQuata) quotas.push('Lakshadweep Quota');
	return quotas.join(', ');
}
export const CustomTableArray = ({ data, fields }: any) =>
	data?.length ? (
		<div className='overflow-x-auto rounded-xl'>
			<table className='min-w-full bg-gradient-to-r from-gray-50 to-gray-200 rounded-xl'>
				<thead className='bg-gray-100'>
					<tr>
						{fields?.map((fieldKey: any) => (
							<th key={fieldKey} className='px-4 py-3 text-left font-semibold text-gray-800 border border-gray-300' style={{ fontSize: '16px' }}>
								{fieldKey.charAt(0).toUpperCase() + fieldKey.slice(1)}
							</th>
						))}
					</tr>
				</thead>
				<tbody className='divide-y divide-gray-300'>
					{data?.map((item: any, index: any) => (
						<tr key={index}>
							{fields?.map((fieldKey: any) => (
								<td key={fieldKey} className='px-4 py-2 text-gray-900 font-normal bg-white text-left border border-gray-300' style={{ fontSize: '16px' }}>
									{item[fieldKey]}
								</td>
							))}
						</tr>
					))}
				</tbody>
			</table>
		</div>
	) : null;

export const degreeOptions = ['BA Communicative English', 'BA Economics', 'BA Journalism And Mass Communication', 'BA Tourism Administration', 'Bachelor of Business Administration', 'Bachelor of Business Management', 'Bachelor of Commerce', 'Bachelor of Commerce Model I', 'Bachelor of Commerce Model II', 'Bachelor of Commerce Model III', 'Bachelor of Computer Applications(BCA)', 'Bachelor of Social Work', 'BSc Chemistry', 'BSc Computer Science', 'BSc Information Technology', 'BSc Mathematics', 'BSc Physics', 'BSc Statistics', 'Other'];
export const addressKey = ['houseName', 'place', 'postOffice', 'village', 'panchayatMunicipalityCorporation', 'nationality', 'state', 'district', 'pinCode'];
export const permanentAddressKey = ['permanentHouseName', 'permanentPlace', 'permanentPostOffice', 'permanentVillage', 'permanentPanchayatMunicipalityCorporation', 'permanentNationality', 'permanentState', 'permanentDistrict', 'permanentPinCode'];
export const sslcKey = ['sslcInstitutionName', 'sslcRegisterNo', 'sslcBoard', 'sslcPercentage', 'sslcYearOfPass'];
export const plusTwoKey = ['plusTwoInstitutionName', 'plusTwoRegisterNo', 'plusTwoState', 'plusTwoBoard', 'plusTwoStream', 'plusTwoPercentage', 'totalMarkObtaioned', 'totalMarks', 'plusTwoYearOfPass', 'plusTwoNoOfChance'];
export const degreeKey = ['degreeInstitutionName', 'degreeRegisterNo', 'degreeCourse', 'degreeUniversity', 'degreeSpecialisation', 'degreeYearOfPass', 'degreeScheme', 'degreeInstState', 'degreeMarkSystem', 'degreeNoOfChance', 'isBonusMark'];
export const preferenceKey = ['preferedCourse1'];
export const familykey = ['name', 'qualification', 'relation', 'job', 'mobile'];
export const travelKey = ['typeOfVehicle', 'travelStart', 'travelTo', 'km'];
export const culturalKey = ['item', 'type', 'specialised'];

export const RenderFilePreview = ({ fileURL }: any) => {
	return (
		<>
			<div style={{ height: '1350px', width: '100%', overflow: 'auto', margin: 'auto' }}>
				<object data={fileURL} type='application/pdf' style={{ width: '100%', height: '100%' }}>
					<iframe src={fileURL} title='PDF Preview' style={{ width: '100%', height: '100%' }}>
						<p>
							Your browser does not support PDFs.
							<a href={fileURL}>Download the PDF</a>.
						</p>
					</iframe>
				</object>
			</div>
		</>
	);
};
export const getAdmissionNumber = (collegeId: any, type: any, applicationNo: any) => {
	if (collegeId === 'COL-D6DE25F23FF5-40A6-9E76-4A2AF63D1B5F') {
		const prefix = type?.toUpperCase() === 'UG' ? '241' : '242';
		return prefix + applicationNo?.toString().padStart(4, '0');
	} else {
		return applicationNo;
	}
};


